import { useContext } from "react";
import { AttendanceIdContext } from "@/contexts/AttendanceIdContext";

export function useAttendanceId() {
	const value = useContext(AttendanceIdContext);

	return value;
}
